<template>
    <div class="">
        <top-header :type="3" :isShow="false" :bgColor="bgColor" :textColor="textColor"/>
        <div class="top_banner" ref="topBanner">
            <swiper class="swiper" :options="swiperOptionh" ref="mySwiper">
                <swiper-slide v-for="(items, index1) in brokerCompImgs" :key="index1">
                    <img :src="imgPath + 'sClf/' + items.imgId + '.jpg'" alt="">
                </swiper-slide>
                <swiper-slide v-if="!brokerCompImgs.length">
                    <img v-lazy="" alt="">
                </swiper-slide>
            </swiper>
            <div class="total" v-if="brokerCompImgs.length">{{topSwiperIndex + 1}}/{{brokerCompImgs.length}}</div>
        </div>
        <div class="bor_b">
            <div class="info_con">
                <h3>{{detail.compName ? detail.compName : '-'}}</h3>
                <div class="info_m">
                    <p class="text long"><span>地址：</span>{{detail.compAddress ? detail.compAddress : '-'}}</p>
                    <div class="m_flex_box flex_vc flex_jz">
                        <p class="text"><span>区域：</span>{{areaName ? areaName : '-'}}</p>
                        <p class="text"><span v-if="compType==0">门店：</span> <span v-if="compType==1">代办点：</span>{{detail.brokerStoreCount ? detail.brokerStoreCount : '-'}}
                        </p>
                        <p class="text"><span v-if="compType==0">经纪人：</span><span v-if="compType==1">操作员：</span>{{detail.brokerCount ? detail.brokerCount : '-'}}
                        </p>
                    </div>
                    <div class="blue_con m_flex_box flex_vc flex_jz">
                        <div class="left m_flex_box flex_vc">
                            <img src="@/assets/img/u.png" alt="">
                            <span>联系人：{{detail.compPerson ? detail.compPerson : '-'}}</span>
                        </div>
                        <a  @click.stop="callTo(detail.compPhone, 1, detail.id)" class="right m_flex_box flex_vc">
                            <img src="@/assets/img/p.png" alt="">
                            <span>{{detail.compPhone ? detail.compPhone : '-'}}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="bor_b" v-if="count1!=0" >
            <div class="shop_con">
                <div class="tit_con m_flex_box flex_vc flex_jz">
                    <h3 v-if="compType==0"> 门店（{{count1}}）</h3>
                    <h3 v-if="compType==1"> 代办点（{{count1}}）</h3>
                    <router-link v-show="count1>3"  :to="{path:'/shopList',query:{area:area,compId:compId,compType:compType}}">
                        <span>查看全部</span>
                        <van-icon name="arrow"/>
                    </router-link>
                </div>
                <div class="inner m_flex_box flex_vc flex_jz" v-for="(item, index) in list" :key="index"
                     @click="toDetail('/shopDetail', {id:item.id,compType:compType})">
                    <img v-lazy="imgPath + 'sCLF/' + item.headerPic + '.jpg'" alt="">
                    <div class="right">
                        <h3 class="line_comp1">{{item.storeName ? item.storeName : '-'}}</h3>
                        <p class="address line_comp1">{{item.address ? item.address : '-'}}</p>
                        <div class="bottom m_flex_box flex_vc">
                            <p class="m_flex_box">
                                <img src="@/assets/img/person_sm.png" alt="">
                                <span>{{item.storePerson ? item.storePerson : '-'}}</span>
                            </p>
                            <a @click.stop="callTo(item.storePhone, 1, item.id)" class="m_flex_box">
                                <img src="@/assets/img/phone_sm.png" alt="">
                                <span>{{item.storePhone ? item.storePhone : '-'}}</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div v-show="count1>3" class="toList" @click="toList('/shopList', {area:area,compId:compId,compType:compType})">
                    查看全部{{count1}}个门店
                </div>
            </div>
        </div>
        <div class="bor_b" v-if="count2!=0" >
            <div class="peo_main">
                <div class="tit_con m_flex_box flex_vc flex_jz">
                    <h3 v-if="compType==0">经纪人（{{count2}}）</h3>
                    <h3 v-if="compType==1">操作员（{{count2}}）</h3>
                    <router-link v-show="count2>6" :to="{path:'/personList',query:{area:area,compId:compId,compType:compType}}">
                        <span>查看全部</span>
                        <van-icon name="arrow"/>
                    </router-link>
                </div>
                <div class="people_con">
                    <div class="inner" v-for="(item ,index) in list2" :key="index"
                         @click="toDetail('/agentDetail', {id:item.id,compType:compType})">
                        <img v-lazy="imgPath + 'sCLF/' + item.brokerImg + '.jpg'" alt="" class="atavr">
                        <p class="name">{{item.brokerName ? item.brokerName : '-'}}</p>
                        <p class="intro line_comp1">{{item.compName ? item.compName : '-'}}-{{item.storeName ? item.storeName : '-'}}</p>
                        <div class="btn_con m_flex_box flex_vc flex_jz">
                            <div @click.stop="toTalk(item.id)">
                                <img src="@/assets/img/zx.png" alt="">
                                <p>在线咨询</p>
                            </div>
                            <a @click.stop="callTo(item.phone, 1, item.id)">
                                <img src="@/assets/img/phone.png" alt="">
                                <p>电话咨询</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="" v-if="count3!=0">
            <div class="house_main">
                <div class="tit_con m_flex_box flex_vc flex_jz">
                    <h3>房源（{{count3}}）</h3>
                    <router-link :to="{path:'/houseOraList',query:{area:area,compId:compId,compType:compType}}" v-show="count3>5">
                        <span>查看全部</span>
                        <van-icon name="arrow"/>
                    </router-link>
                </div>
                <div class="list_con old_list">
                    <div class="inner m_flex_box flex_vc" v-for="(item, index) in list3" :key="index"
                         @click="toDetail('/houseDetail', {houseListedId: item.id,mainId:item.mainId,compType:compType})">
                        <div class="inner_l">
                            <img class="banner" v-lazy="imgPath + 'sClf/' + item.fileId + '.jpg'">
                        </div>
                        <div class="new_r">
                            <div class="m_flex_box flex_vc flex_jz tit">
                                <h4 class="line_comp1">{{item.tgmc ? item.tgmc : '-'}}</h4>
                                <i>在售</i><!-- 返回数据没有字段 -->
                            </div>
                            <p class="line_comp1 col_gray">{{item.xzqh | format()}} / {{item.zmjCount ? item.zmjCount : '-'}}m² / {{item.room ? item.room : '-'}}室{{item.hall ? item.hall : '-'}}厅</p>
                            <div class="m_flex_box flex_jz">
                                <div class="price m_flex_box flex_vb">
                                    <h4>{{item.listedPrice ? item.listedPrice / 10000 : '-'}}万</h4>
                                    <p>{{item.unitPrice ? item.unitPrice : '-'}}元/平</p>
                                </div>
                                <a @click.stop="callTo_(item.phoneNum, item.listedType, item.listedUserId)" class="tel"><img src="@/assets/img/tel.png" alt=""></a>
                            </div>
                            <div class="num m_flex_box flex_vc">
                                <img src="@/assets/img/check.png" alt=""><span>核验编码</span>{{item.uniqueCode ? item.uniqueCode : '-'}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="toList" @click="toList('/houseOraList', {area:area,compId:compId,compType:compType})" v-show="count3>5" >
                    查看全部{{count3}}个房源
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import qs from 'qs'
    import topHeader from '@/components/header'
    import {ImagePreview} from 'vant'
    import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
    import 'swiper/swiper-bundle.css'
    export default {
        data() {
            return {
                bgColor: 'transparent',
                textColor: '#fff',
                topSwiperIndex: 0,
                swiperOptionh: {
                    on: {
                        slideChangeTransitionStart: (data) => {
                            this.topSwiperIndex = data.activeIndex;
                        },
                    },
                },
                swiperOption: {
                    effect: 'coverflow',
                    grabCursor: true,
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    loop: true,
                },
                detail: '',
                id: this.$route.query.id,
                areaName: '',
                list: [],
                list2: [],
                list3: [],
                count1: 0,
                count2: 0,
                count3: 0,
                area: '',
                compId: '',
                brokerCompImgs: [],
                compType: this.$route.query.compType
            };
        },
        components: {
            topHeader,
            Swiper,
            SwiperSlide,
            [ImagePreview.Component.name]: ImagePreview.Component
        },
        mounted() {
            this.getDetail().then(() => {
                this.getBrokerStoreList();
                this.getBrokerList();
                this.getHouseByInfo();
            });
            window.addEventListener('scroll', this.handleScroll);
        },
        filters: {
            format(data) {
                if (data === "320302000000") {
                    return "鼓楼区";
                } else if (data === "320311000000") {
                    return "泉山区";
                } else if (data === "320303000000") {
                    return "云龙区";
                } else if (data === "320398000000") {
                    return "金山桥";
                } else if (data === "320312000000") {
                    return "铜山区";
                } else if (data === "320305000000") {
                    return "贾汪区";
                } else if (data === "320399000000") {
                    return "高新区";
                } else if (data === "320397000000") {
                    return "港务区";
                }else if (data === "320382000000") {
                    return "邳州市";
                } else if (data === "320381000000") {
                    return "新沂市";
                } else if (data === "320321000000") {
                    return "丰县";
                } else if (data === "320324000000") {
                    return "睢宁";
                } else if (data === "320322000000") {
                    return "沛县";
                } else if (data === "320") {
                    return "市区";
                }
            }
        },
        methods: {
            toTalk(id) {
                this.$router.push({
                        path: '/chat',
                        query: {
                            id
                        }
                })
            },
            getDetail() {
                return new Promise((resolve) => {
                    this.$http.post('cms/brokerComp/permit/getBrokerComp.do', qs.stringify({
                        id: this.id,
                    })).then(res => {
                        this.loading = false;
                        if (res.success) {
                            var Img=this.logoImg
                            var url = window.location.href;
                            var hosts = url.split('/#/')[0];//获取域名加打包文件夹名称
                            var shareImg = hosts.concat('/'+Img);
                            this.$share(res.obj.compName,res.obj.compAddress,shareImg)
                            var areas = this.main.zhArea(res.obj.area);
                            this.areaName = areas;
                            this.$set(this, 'detail', res.obj);
                            this.brokerCompImgs = res.obj.brokerCompImgs;
                            this.area = res.obj.area;
                            this.compId = res.obj.id;
                            this.loading = false;
                            resolve()
                        }
                    })
                })
            },

            callTo(phone, lx, infoId) {
                if(!phone) {
                    this.$dialog.alert({
                        title: '提示',
                        message: '暂无可拨打电话'
                    });
                    return;
                }
                this.$new.post('telTj/addTeltj.do', qs.stringify({
                    phone,
                    lx,
                    infoId
                })).then(res => {
                    window.location.href = `tel:${phone}`
                })
            },

            callTo_(phone, lx, infoId) {
                if(!phone) {
                    this.$dialog.alert({
                        title: '提示',
                        message: '暂无可拨打电话'
                    });
                    return;
                }
                this.$http.post('cms/onlineUser/reg/isLogin.do').then(res => {
                    if (res.success) {
                        this.$new.post('telTj/addTeltj.do', qs.stringify({
                            phone,
                            lx,
                            infoId
                        })).then(res => {
                            window.location.href = `tel:${phone}`
                        })
                    } else {
                        this.$toast(res.msg)
                    }
                })
            },

            getBrokerStoreList() {
                this.$http({
                    url: 'cms/brokerStore/permit/getBrokerStoreList.do',
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {
                        compType: this.compType,
                        pageSize: 3,
                        offset: 0,
                        area: this.area,
                        compId: this.compId,
                    }
                }).then(res => {
                    if (res.success) {
                        this.count1 = res.obj.totalCount;
                        this.$set(this, 'list', res.obj.rows);
                        this.loading = false;
                        this.finished = true;
                    }
                })
            },
            getBrokerList() {
                this.$http({
                    url: 'cms/broker/permit/getBrokerList.do',
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {
                        compType: this.compType,
                        pageSize: 6,
                        offset: 0,
                        area: this.area,
                        compId: this.compId,
                    }
                }).then(res => {
                    if (res.success) {
                        this.count2 = res.obj.totalCount;
                        this.$set(this, 'list2', res.obj.rows);
                        this.loading = false;
                        this.finished = true;
                    }
                })
            },
            getHouseByInfo() {
                this.$http({
                    url: 'cms/houseListed/permit/getHouseByInfo.do',
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {
                        pageSize: 5,
                        offset: 0,
                        area: this.area,
                        compId: this.compId,
                    }
                }).then(res => {
                    if (res.success) {
                        this.count3 = res.obj.totalCount;
                        this.$set(this, 'list3', res.obj.rows);
                        this.loading = false;
                        this.finished = true;
                    }
                })
            },
            toList(path, json) {
                this.$router.push({
                    path,
                    query: json
                })
            },
            toDetail(path, json) {
                this.$router.push({
                    path,
                    query: json
                })
            },
            handleScroll() {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                if (scrollTop > (document.documentElement.clientWidth / 7.5) * 5.6) {
                    this.textColor = '#000';
                    this.bgColor = '#fff';
                } else {
                    this.textColor = '#fff';
                    this.bgColor = 'transparent';
                }
            },
        },
    };
</script>
<style lang="less" scoped>
    .top_banner {
        position: relative;
        height: 5.64rem;

        .total {
            background-color: rgba(0, 0, 0, 0.5);
            color: #fff;
            font-size: 0.24rem;
            width: 1.2rem;
            line-height: 0.5rem;
            position: absolute;
            bottom: 0.24rem;
            right: 0.4rem;
            z-index: 9;
            text-align: center;
            border-radius: 0.25rem;
        }
        .swiper {
            width: 100%;
            .swiper-slide {
                height: 5.64rem;
            }
            img {
                height: 5.64rem;
                width: 100%;
            }
        }


        .slide_video_con {
            position: relative;

            .cover {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 5.64rem;
                background-color: rgba(0, 0, 0, 0.3);

                i {
                    color: #fff;
                    font-size: 1.4rem;
                }
            }

        }
    }

    .info_con {
        padding: 0.3rem 0;
        width: 7.04rem;
        margin: 0 auto;

        h3 {
            font-size: 0.34rem;
            font-weight: 800;
            margin-bottom: 0.2rem;
        }

        .text {
            margin-bottom: 0.2rem;

            span {
                font-size: 0.26rem;
                color: #939393;
            }
        }

        .blue_con {
            margin-top: 0.2rem;
            background-color: #EEF4FF;
            border-radius: 0.04rem;
            height: 0.84rem;
            padding: 0 0.18rem;

            img {
                margin-right: 0.12rem;
            }

            .left {
                color: #202020;
                font-size: 0.28rem;

                img {
                    width: 0.32rem;
                }
            }

            .right {
                color: #2F72F5;
                font-weight: 800;

                img {
                    width: 0.28rem;
                }
            }
        }
    }

    .shop_con {
        width: 7.04rem;
        margin: 0.2rem auto;

        .inner {
            padding: 0.34rem 0;
            border-bottom: 1px solid #f5f5f5;

            > img {
                width: 2.14rem;
                height: 1.6rem;
                margin-right: 0.26rem;
            }

            .right {
                width: 4.44rem;

                h3 {
                    font-size: 0.3rem;
                    font-weight: 600;
                }

                .address {
                    font-size: 0.24rem;
                    color: #505050;
                    margin: 0.2rem 0 0.3rem;
                }

                .bottom {
                    font-size: 0.24rem;
                    color: #505050;

                    p {
                        margin-right: 0.4rem;
                    }

                    img {
                        width: 0.32rem;
                        height: 0.32rem;
                        margin-right: 0.12rem;
                    }
                }
            }
        }
    }

    .toList {
        line-height: 0.62rem;
        text-align: center;
        background-color: #F3F3F3;
        border-radius: 0.02rem;
    }

    .tit_con {
        h3 {
            font-size: 0.34rem;
            font-weight: 800;
        }

        a {
            font-size: 0.24rem;
            color: #A9AAAE;
        }
    }

    .peo_main {
        width: 7.04rem;
        margin: 0.2rem auto;
        padding-top: 0.1rem;

        .people_con {
            white-space: nowrap;
            overflow: auto;
            padding: 0.9rem 0.08rem 0.08rem;

            .inner {
                display: inline-block;
                width: 2.7rem;
                height: 3.04rem;
                box-sizing: border-box;
                box-shadow: 0rem 0.02rem 0.08rem rgba(0, 0, 0, 0.15);
                border-radius: 0.04rem;
                padding: 0 0.2rem;
                box-sizing: border-box;
                margin-right: 0.16rem;
                text-align: center;

                &:last-child {
                    margin-right: 0;
                }

                .atavr {
                    position: relative;
                    top: -0.48rem;
                    width: 1.3rem;
                    height: 1.3rem;
                    border-radius: 50%;
                    display: block;
                    margin: 0 auto;
                }

                .name {
                    font-size: 0.26rem;
                    margin-top: -0.34rem;
                    font-weight: 800;
                }

                .intro {
                    font-size: 0.26rem;
                    margin: 0.08rem 0 0.14rem;
                }

                .btn_con {
                    width: 100%;
                    padding-top: 0.12rem;
                    border-top: 1px solid #f4f4f4;
                    text-align: center;
                    font-size: 0.22rem;
                    color: #606060;

                    img {
                        width: 0.4rem;
                        height: 0.4rem;
                    }
                }
            }
        }
    }

    .list_con {
        margin: 0.05rem auto 0;
        width: 7.04rem;

        .inner {
            padding: 0.35rem 0;
            border-bottom: 1px solid #F4F4F4;
        }

        .banner {
            width: 2.44rem;
            height: 1.84rem;
        }

        .new_r {
            .tel {
                width: 0.36rem;
                height: 0.36rem;

                img {
                    width: 100%;
                }
            }

            img {
                width: 100%;
            }

            width: 4.25rem;
            margin-left: 0.3rem;

            .col_gray {
                font-size: 0.24rem;
                color: #505050;
            }

            .tit {
                h4 {
                    font-size: 0.36rem;
                    color: #101010;
                    font-weight: 800;
                    width: 3rem;
                }

                i {
                    //width: 0.6rem;
                    padding: 0 0.04rem;
                    line-height: 0.34rem;
                    color: #2F72F5;
                    font-size: 0.24rem;
                    text-align: center;
                    border: 1px solid currentColor;
                    box-sizing: border-box;
                    border-radius: 0.02rem;
                }

                span {
                    width: 0.6rem;
                    height: 0.34rem;
                    text-align: center;
                    line-height: 0.34rem;
                    color: #fff;
                    background-color: #24D064;
                    font-size: 0.24rem;
                    border-radius: 0.02rem;
                }
            }
        }
    }

    .old_list {
        .inner {
            .inner_l {
                position: relative;

                i {
                    width: 0.6rem;
                    height: 0.34rem;
                    text-align: center;
                    line-height: 0.34rem;
                    color: #fff;
                    background-color: #24D064;
                    font-size: 0.24rem;
                    position: absolute;
                    display: block;
                    top: 0;
                }
            }

            .new_r {
                .tit {
                    margin-bottom: 0.08rem;
                }

                .col_gray {
                    margin: 0.04rem 0;
                }

                .price {
                    h4 {
                        font-size: 0.34rem;
                        color: #FF4532;
                        margin-bottom: 0;
                        font-weight: 800;
                    }

                    p {
                        font-size: 0.24rem;
                        color: #AAAAAA;
                        margin-left: 0.12rem;
                    }
                }

                .num {
                    margin-top: 0.04rem;
                    color: #3072F5;

                    img {
                        width: 0.3rem;
                        height: 0.3rem;
                    }

                    span {
                        margin: 0 0.1rem;
                        color: #383333;
                    }
                }
            }
        }
    }

    .house_main {
        width: 7.04rem;
        margin: 0.2rem auto;
        padding-top: 0.1rem;
    }
</style>